module.exports = __webpack_public_path__ + "static/fonts/NanumGothic-Regular.bc9d215.eot";